import { uuidV4 } from '../util/others/uuid-v4.js';

/** Creates a Joint. The id of the element is defined internally */
const CreateJoint = (partial) => ({
    pos: [0, 0, 0],
    bones: [],
    cornerFlip: false,
    id: uuidV4(),
    ...partial
});

export { CreateJoint };
//# sourceMappingURL=create-joint.js.map
